var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomainsTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FF824D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11L24.5 29M11.5 25L20.5 20M16.3 29H24.7C26.3802 29 27.2202 29 27.862 28.673C28.4265 28.3854 28.8854 27.9265 29.173 27.362C29.5 26.7202 29.5 25.8802 29.5 24.2V15.8C29.5 14.1198 29.5 13.2798 29.173 12.638C28.8854 12.0735 28.4265 11.6146 27.862 11.327C27.2202 11 26.3802 11 24.7 11H16.3C14.6198 11 13.7798 11 13.138 11.327C12.5735 11.6146 12.1146 12.0735 11.827 12.638C11.5 13.2798 11.5 14.1198 11.5 15.8V24.2C11.5 25.8802 11.5 26.7202 11.827 27.362C12.1146 27.9265 12.5735 28.3854 13.138 28.673C13.7798 29 14.6198 29 16.3 29Z",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainsTitle);
export default __webpack_public_path__ + "static/media/domainsTitle.6c45a5d1d7c54387e6b843bfb9fe36da.svg";
export { ForwardRef as ReactComponent };